import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Row, Col, Spinner } from "reactstrap"
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import FileUpload from "components/Common/file-upload/file-upload.component"
import { providerPrefix } from "configs/routePrefix"
import { toast } from "react-toastify"
import CancelModal from "components/CancelModal"
import LeadService from "services/Provider/LeadService"
import SelectOptions from "components/SelectOptions"
import AppoinmentService from "services/Provider/AppoinmentService"
import Select from "react-select";
import { SuccessOk, SuccessCreated } from "configs/statusCode"
import BuildingService from "services/Admin/BuildingService"
import PropertyService from "services/Admin/PropertyService"
import SalesRepsService from "services/Admin/SalesRepsService"
import SuccessModal from "components/SucessModal"
import moment from "moment"
import {useSelector} from "react-redux"
import { unitTypeOptions } from "Enums/fixedData";
import SelectComponent from "pages/Admin/Deals/Select";
import ResaleService from "services/Provider/ResaleService";
import CompoundService from "services/Provider/CompoundService";
const initialState = {
    title: "",
    description: "",
    date: "",
    time: "",
    status: "upcoming",
    selectedLead: null,
    activityType: null,
    selectedBulding: null,
    selectedCompound: null,
    selectedProperty: null,
    location: "",
    unitType: null,
    selectedResale: null
}

const AddAppointment = (props) => { 
    const [successModal, setSuccessModal] = useState(false)
    const id = props.match.params.id
    const leadId= props.match.params.leadId
    const [formState, setFormState] = useState(initialState)
    const [modal, setModal] = useState(false)
    const [leadsOptions, setLeadOptions] = useState([])
    const [CompoundOptions, setCompoundptions] = useState([])
    const [buildingOptions, setBuildingOptions] = useState([])
    const [propertyOptions, setPropertyOptions] = useState([])
    const [resaleOption, setResaleOption] = useState()
    const leadService = new LeadService()
    const appoinmentService = new AppoinmentService()
    const buildingService = new BuildingService()
    const propertyService = new PropertyService()
    const resaleService = new ResaleService()
    const compoundService = new CompoundService()
    const [loading, setLoading] = useState(false)
    const [unitType , setUnitType] =useState()
    const salesRep = useSelector(state => state.Auth.userId)
    // const currentday = new Date().getFullYear() + '-' + ((new Date().getMonth() + 1) < 10 ? `0${(new Date().getMonth() + 1)}` : (new Date().getMonth() + 1)) + '-' + new Date().getDate()

    useEffect(() => {
        id !== "add" && !!id && appoinmentService.find(id).then((res) => {
            if (res && res.status === SuccessOk) {
                const data = res.data
                if(!!data?.other){
                    setFormState({
                        unitType: {label: 'Other'},
                        resale_name: data?.other,
                        title: data.title,
                        description: data.description,
                        selectedLead: {
                            label: `${data?.lead_id} / ${data.client?.name}`,
                            value: data?.lead_id
                        },
                        sales_rep_id: {
                            label: `${data.sales_rep?.id} / ${data.sales_rep?.name}`,
                            value: data.sales_rep?.id
                        },
                    })
                    setUnitType({label: 'Other'})
                } else if(!!data?.unit?.building?.id || (!!data?.unit?.compound?.name?.en && !!data?.unit?.name?.en)){
                    setFormState({
                        unitType: {label: 'Property in Compound'},
                        time: moment(data.time, ["h:mm A"]).format("HH:mm"),
                        status: data.status[0].toLowerCase() + data.status.substring(1),
                        selectedBulding: data.unit?.building?.id ? {
                            label: data.unit?.building?.name?.en,
                            value: data.unit?.building?.id,
                        } : null,
                        selectedCompound: {
                            label: data.unit.compound.name.en,
                            value: data.unit.compound.id,
                        },
                        selectedProperty: {
                            label: data.unit.name.en,
                            value: data.unit.id,
                        },
                        title: data.title,
                        description: data.description,
                        date: data.date,
                        selectedLead: {
                            label: `${data?.lead_id} / ${data.client?.name}`,
                            value: data?.lead_id
                        },
                        activityType: {
                            label: data.type,
                            value: data.type
                        },
                        sales_rep_id: {
                            label: `${data.sales_rep?.id} / ${data.sales_rep?.name}`,
                            value: data.sales_rep?.id
                        },
                        location: data?.type === "visit" ? data.location : ""
                    })
                } else if(!data?.unit && !!data?.resale?.compound?.name?.en && !!data?.resale?.name?.en){
                    setFormState({
                        unitType: {label: 'Resale in Compound'},
                        time: moment(data.time, ["h:mm A"]).format("HH:mm"),
                        status: data.status[0].toLowerCase() + data.status.substring(1),
                        selectedCompound: {
                            label: data.resale.compound.name.en,
                            value: data.resale.compound.id,
                        },
                        selectedResale: {
                            label: data.resale.name.en,
                            value: data.resale.id,
                        },
                        title: data.title,
                        description: data.description,
                        date: data.date,
                        selectedLead: {
                            label: `${data?.lead_id} / ${data.lead?.name}`,
                            value: data?.lead_id
                        },
                        activityType: {
                            label: data.type,
                            value: data.type
                        },
                        // selectedProperty: data?.unit_id,
                        // selectedBulding: data.building_id,
                        // selectedCompound: data.compound_id,
                        sales_rep_id: {
                            label: `${data.sales_rep?.id} / ${data.sales_rep?.name}`,
                            value: data.sales_rep?.id
                        },
                        location: data?.type === "visit" ? data.location : ""
                    })
                    setUnitType({label: 'Resale in Compound'})
                } else {
                    setFormState({
                        unitType: {label: 'Resale Unit Outside Compound'},
                        time: moment(data.time, ["h:mm A"]).format("HH:mm"),
                        status: data.status[0].toLowerCase() + data.status.substring(1),
                        selectedResale: {
                            label: data.resale.name.en,
                            value: data.resale.id,
                        },
                        title: data.title,
                        description: data.description,
                        date: data.date,
                        selectedLead: {
                            label: `${data?.lead_id} / ${data.lead?.name}`,
                            value: data?.lead_id
                        },
                        activityType: {
                            label: data.type,
                            value: data.type
                        },
                        // selectedProperty: data?.unit_id,
                        // selectedBulding: data.building_id,
                        // selectedCompound: data.compound_id,
                        sales_rep_id: {
                            label: `${data.sales_rep?.id} / ${data.sales_rep?.name}`,
                            value: data.sales_rep?.id
                        },
                        location: data?.type === "visit" ? data.location : ""
                    })
                    setUnitType({label: 'Resale Unit Outside Compound'})
                }
            }
        })
    }, [])
    
    useEffect(() => {
        const id = formState ?.selectedCompound ?.value
            if (id && formState?.unitType?.label === "Property in Compound") {
            buildingService.getDropDown(id).then(res => {
                const newOptions = res.data?.map(item => {
                    return {
                        label: item.name.en,
                        value: item.id
                    }
                })
                setBuildingOptions(newOptions)
            })
        }
    }, [formState.selectedCompound])

    useEffect(() => {
        
        const buildId = formState ?.selectedBulding ?.value
        if (buildId) {
            propertyService.getDropDown(buildId).then(res => {
                const newOptions = res.data?.map(item => {
                    return {
                        label: item.name.en,
                        value: item.id
                    }
                })
                setPropertyOptions(newOptions)
            })
        }
    }, [formState.selectedBulding])

    useEffect(() => {
        const id = formState ?.selectedCompound ?.value
        if(formState?.unitType?.label === "Property in Compound"){
        if (id) {
          propertyService.getDropDownCustom(id).then(res => {
              const newOptions = res.data?.map(item => {
                  return {
                      label: item.name.en,
                      value: item.id
                  }
              })
              setPropertyOptions(newOptions)
          })
      }
        } else if(formState?.unitType?.label === "Resale in Compound"){
        if (id) {
          resaleService.getResaleInCompoundDropDown(id).then(res => {
              const newOptions = res.data?.map(item => {
                  return {
                      label: item.name.en,
                      value: item.id
                  }
              })
              setResaleOption(newOptions)
          })
      }
        }
    }, [formState.selectedCompound])

    useEffect(() => {
        if(formState?.unitType?.label === "Resale Unit Outside Compound"){
            resaleService.getIndependentResaleDropDown().then(res => {
                const newOptions = res.data?.map(item => {
                    return {
                         label: item.name.en ?item.name.en :item.name,
                         value: item.id
                     }
                })
                setResaleOption(newOptions)
            })
        }
        if(formState?.unitType?.label === "Resale in Compound"){
            compoundService.getCompoundWithResaleDropDown().then(res => {
                const newOptions = res.data.map(item => {
                    return {
                         label: item.name.en ? item.name.en :item.name,
                         value: item.id
                     }
                })
                setCompoundptions(newOptions)
            })
        }
    }, [formState.unitType])

    useEffect(() => {
        if(leadsOptions.length){
           const lead=  leadsOptions?.find(item=>parseInt(item.value)===parseInt(leadId))
         if(lead){
            setFormState({...formState,selectedLead:lead})
         }
        }
    }, [leadsOptions])

    const handleValidSubmit = (e, v) => {
        if (!formState.selectedLead) {
            toast.error("Select Client Name")
            return
        } 
        else if (!formState.activityType) {
            toast.error("Select Activity Type")
            return
        }
        else if (!formState.unitType) {
            toast.error("Select Unit Type")
            return
        }
        else if ((formState.unitType.label === 'Property in Compound' || formState.unitType.label === 'Resale in Compound') && !formState.selectedCompound) {
            toast.error("Select Compound")
            return
        }
        else if ((formState.unitType.label === 'Resale in Compound' || formState.unitType.label === 'Resale Unit Outside Compound') && !formState.selectedResale) {
            toast.error("Select Resale")
            return
        } else if (formState.unitType.label === 'Property in Compound' && !formState.selectedProperty) {
            toast.error("Select Property")
            return
        }  else if ((formState?.unitType.label === "other" && !formState.resale_name)) {
            toast.error("Please Enter Resale Name")
            return
        } else {
            let info ={}
            setLoading(true)
             
            if (formState.activityType.value === "visit") {
                if(!validate(formState.location)){
                    toast.error("Location format invalid")
                  setLoading(false)
                    return
                }else{
                    data["location"] = formState.location 
                }
            }
            
            if (id!=="add" && !!id ) {
                if(formState.unitType.label === 'Property in Compound'){
                    info = {
                        compound_id: formState?.selectedCompound?.value,
                        building_id: formState?.selectedBulding?.value,
                        unit_id: formState?.selectedProperty?.value,
                        resale: null,
                        other: null
                    }
                } else if(formState.unitType.label === 'Resale in Compound'){
                    info = {
                        compound_id: formState?.selectedCompound?.value,
                        resale_id: formState?.selectedResale?.value,
                        unit_id: null,
                        other: null
                    }
                }  else if(formState?.unitType?.label === "Resale Unit Outside Compound"){
                    info = {
                        resale_id: formState.selectedResale.value,
                        unit_id: null,
                        other: null
                    }
                } else{
                    info = {
                        other: formState.resale_name,
                        resale_id: null,
                        unit_id: null
                    }
                }
                const data = {
                    title: formState.title,
                    description: formState.description,
                    date: formState.date,
                    time: formState.time,
                    status: formState.status,
                    type: formState.activityType.value,
                    lead_id: formState.selectedLead.value,
                    ...info
                 }
                appoinmentService.update(id,data).then(response => {
                     if (response && response.status === SuccessOk) {
                        setLoading(false)
                        setSuccessModal(true)
                    }else{
                        setLoading(false)
                    }
                })
            } else {
                if(formState.unitType.label === 'Property in Compound'){
                    info = {
                        compound_id: formState?.selectedCompound?.value,
                        building_id: formState?.selectedBulding?.value,
                        unit_id: formState?.selectedProperty?.value,
                    }
                } else if(formState.unitType.label === 'Resale in Compound'){
                    info = {
                        compound_id: formState?.selectedCompound?.value,
                        resale_id: formState?.selectedResale?.value,
                    }
                } else if (formState?.unitType?.label === "Resale Unit Outside Compound"){
                    info = {
                        resale_id: formState.selectedResale.value,
                    }
                } else {
                    info= {
                        other: formState.resale_name
                    }
                }
                const data = {
                    title: formState.title,
                    description: formState.description,
                    date: formState.date,
                    time: formState.time,
                    status: formState.status,
                    type: formState.activityType.value,
                    lead_id: formState.selectedLead.value,
                    ...info
                 }
                appoinmentService.create(data).then(response => {
                     if (response && response.status === SuccessCreated) {
                        setSuccessModal(true)
                    }
                    setLoading(false)
                })
            }
        }
    }

    const handleFieldChange = (e) => {
        setFormState({ ...formState, [e.target.name]: e.target.value })
    }
    useEffect(() => {
       if(salesRep){
        leadService.getDropDown(salesRep).then(res => {
            const newOptions = res.data.map(item => {
                return {
                    label: `${item.id} / ${item.name}`,
                    value: item.id
                }
            })
            setLeadOptions(newOptions)
        })
       }
    }, [salesRep])

    return (
        <React.Fragment>
            <div className='page-content'>
                <MetaTags>
                    <title>Book Appoinment</title>
                </MetaTags>
                <Container fluid>
                    <h4>
                        {/* <button className="p-0 m-0 border-0 bg-light"
                            onClick={() => {
                                setModal(true)
                            }}>
                            <i className="fa fa-arrow-left text-primary me-2"></i>
                        </button>
                         */}
                        Book Appointment
          </h4>
                    <AvForm
                        className='form-horizontal'
                        onValidSubmit={(e, v) => {
                            handleValidSubmit(e, v)
                        }}>
                        <Card className="w-100 mt-4">
                            <CardBody>
                                <Row className="mb-4">
                                    <Col md={6}>
                                        <div className='mb-3'>
                                            <AvField
                                                name='title'
                                                label="Appointment Title"
                                                className='form-control'
                                                placeholder='Appointment Title'
                                                required
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.title}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <label>Client Name</label>
                                        <Select
                                            placeholder='Select'
                                            options={leadsOptions}
                                            className='mb-3 '
                                            onChange={data => setFormState({ ...formState, selectedLead: data })}
                                            value={formState.selectedLead}
                                            setOptions={options => setLeadOptions(options)}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <div className='mb-3'>
                                            <AvField
                                                name='date'
                                                label="Date"
                                                className='form-control'
                                                required
                                                type='date'
                                                onChange={(e) => {
                                                    handleFieldChange(e)
                                                }}
                                                bsSize="lg"
                                                value={formState.date}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className='mb-3'>
                                            <AvField
                                                name='time'
                                                label="Time"
                                                className='form-control'
                                                placeholder='Type Time'
                                                required
                                                type='time'
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.time}
                                            />
                                        </div>
                                    </Col>
                                    <Col md={6} className='mt-2'>
                                        <label>Activity Type </label>
                                        <Select
                                            placeholder='Select'
                                            options={[{
                                                label: "call", value: "call",

                                            }, {
                                                label: "meeting", value: "meeting",
                                            }, {
                                                label: "visit", value: "visit"
                                            }]}
                                            className='mb-3 '
                                            onChange={data => setFormState({ ...formState, activityType: data })}
                                            value={formState.activityType}
                                        // setOptions={options => setLeadOptions(options)}
                                        />
                                    </Col>
                                    {formState.activityType ?.value === "visit" ?
                                        <Col md={6}>
                                            <div className='mb-3'>
                                                <AvField
                                                    name='location'
                                                    label="Location"
                                                    className='form-control'
                                                    placeholder='Type Location'
                                                    required
                                                    onChange={(e) => handleFieldChange(e)}
                                                    bsSize="lg"
                                                    value={formState.location}
                                                />
                                            </div>
                                        </Col> : null
                                    }
                                    {/* <Col md={6}>
                                        <Label className='p-0 m-0 font-size-13'>
                                            Status
                                       </Label >
                                        <AvRadioGroup className="mt-2" required inline name="status" value={formState.status} onChange={handleFieldChange} >
                                            <AvRadio label="Upcoming" value="upcoming" />
                                            <AvRadio label="Canceled" value="canceled" />
                                            <AvRadio label="Done" value="done" />
                                        </AvRadioGroup>
                                    </Col> */}
                                    {/* <Col md={6}>
                                        <SelectOptions
                                            label='Compound '
                                            placeholder='Select'
                                            options={CompoundOptions}
                                            handleSelectChange={data => {
                                                setFormState({ ...formState, selectedCompound: data, selectedBulding: null, selectedProperty: null })
                                            }}
                                            selectedOption={formState.selectedCompound}
                                            Service={CompoundService}
                                            setOptions={options => setCompoundptions(options)}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <label>Building</label>
                                        <Select
                                            placeholder='Select'
                                            options={buildingOptions}
                                            className='mb-3 '
                                            onChange={data => setFormState({ ...formState, selectedBulding: data, selectedProperty: null })}
                                            value={formState.selectedBulding}
                                            setOptions={options => setBuildingOptions(options)}
                                        />
                                    </Col>
                                    <Col md={6}>
                                        <label>Property</label>
                                        <Select
                                            placeholder='Select'
                                            options={propertyOptions}
                                            className='mb-3 '
                                            onChange={data => setFormState({ ...formState, selectedProperty: data })}
                                            value={formState.selectedProperty}
                                            setOptions={options => setPropertyOptions(options)}
                                        />
                                    </Col> */}
                                    <SelectComponent
                                        id={"unitType"}
                                        label={"Select Unit Type"}
                                        options={unitTypeOptions}
                                        selected={formState.unitType}
                                        validate={validate.unitType}
                                        setOptions={options => setUnitType(options)}
                                        setFormState={(data) => {
                                            setFormState({ ...formState, unitType: data, selectedCompound: null, selectedBulding: null, selectedProperty: null, selectedResale: null })

                                        }}
                                    />
                                    {!!formState.unitType && formState.unitType.label ==="Property in Compound" && <>
                                    <Col md={6}>
                                        <SelectOptions
                                            label='Compound '
                                            placeholder='Select'
                                            options={CompoundOptions}
                                            handleSelectChange={data => {
                                                setFormState({ ...formState, selectedCompound: data, selectedBulding: null, selectedProperty: null })
                                            }}
                                            selectedOption={formState.selectedCompound}
                                            Service={CompoundService}
                                            setOptions={options => setCompoundptions(options)}
                                        />
                                    </Col>
                                    <Col md={6} >
                                        <label>Building</label>
                                        <Select
                                            placeholder='Select'
                                            options={buildingOptions}
                                            className='mb-3 '
                                            onChange={data => setFormState({ ...formState, selectedBulding: data, selectedProperty: null })}
                                            value={formState.selectedBulding}
                                            setOptions={options => setBuildingOptions(options)}
                                        />
                                    </Col>
                                    <SelectComponent
                                        id={"propertyOptions"}
                                        label={"Property"}
                                        options={propertyOptions}
                                        selected={formState.selectedProperty}
                                        validate={validate.selectedProperty}
                                        setOptions={options => setPropertyOptions(options)}
                                        setFormState={(data) => {
                                            setFormState({ ...formState, selectedProperty: data })
                                        }} />
                                    </>}
                                    {!!formState.unitType && formState.unitType.label ==="Resale in Compound" && <>
                                    <Col md={6} className="mt-2">
                                        <label>Compound</label>
                                        <Select
                                            placeholder='Select'
                                            options={CompoundOptions}
                                            onChange={data => {
                                                setFormState({ ...formState, selectedCompound: data, selectedResale: null})
                                            }}
                                            value={formState.selectedCompound}
                                            // Service={CompoundService}
                                            // setOptions={options => setCompoundptions(options)}
                                        />
                                    </Col>
                                    <Col md={6} className="mt-2">
                                        <label>Resale</label>
                                        <Select
                                            placeholder='Select'
                                            options={resaleOption}
                                            className='mb-3 '
                                            onChange={data => setFormState({ ...formState, selectedResale: data})}
                                            value={formState.selectedResale}
                                            setOptions={options => setResaleOption(options)}
                                        />
                                    </Col>
                                    </>}
                                    {!!formState.unitType && formState.unitType.label ==="Resale Unit Outside Compound" && <>
                                    <Col md={6} className="mt-2">
                                        <label>Resale</label>
                                        <Select
                                            placeholder='Select'
                                            options={resaleOption}
                                            className='mb-3 '
                                            onChange={data => setFormState({ ...formState, selectedResale: data})}
                                            value={formState.selectedResale}
                                            setOptions={options => setResaleOption(options)}
                                        />
                                    </Col>
                                    </>}
                                    {!!formState.unitType && formState.unitType.label ==="Other" && <>
                                    <Col md={6}>
                                        <AvField
                                                name='resale_name'
                                                label="Resale Name"
                                                placeholder='Resale Name'
                                                className='form-control'
                                                type="text"
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.resale_name}
                                            />
                                    </Col>
                                    </>}
                                    <Col md={12} className="mt-2">
                                        <div className='mb-3'>
                                            <AvField
                                                name='description'
                                                label="Description"
                                                placeholder='Type Description'
                                                className='form-control'
                                                type="textarea"
                                                onChange={(e) => handleFieldChange(e)}
                                                bsSize="lg"
                                                value={formState.description}
                                            />
                                        </div>
                                    </Col>

                                </Row>
                            </CardBody>
                        </Card>
                        <Row className="d-flex justify-content-between pb-4">
                            <Col>
                                <button
                                    type="button"
                                    className="btn btnUpload btnHeight px-4"
                                    onClick={() => {
                                        setModal(true)
                                    }}
                                    size={"lg"}>
                                    Cancel
                  </button>
                            </Col>
                            <Col>
                            <button
                          disabled={loading ? true :false}
                                    type='submit'
                                    className="btn btn-success btnHeight px-4 float-end"
                                    size={"lg"}
                                >
                                    Submit
                </button>
                            </Col>
                        </Row>
                        <CancelModal modal={modal}
                            setModal={setModal}
                            goBackHandler={() => {
                                props.history.goBack()
                            }}
                        />
                         <SuccessModal
                            modal={successModal}
                            message={id ? "Appointment Edited Successfully" : "New Appointment Added Successfully"}
                            onClick={() =>props.history.goBack()}
                            title={id ? "Edit Appointment " : "Add New Appointment"}
                        />
                    </AvForm>
                </Container>
            </div>
        </React.Fragment>
    )
}
let validate = (str) => {
    let count = 0
    for (let i = 0; i < str.length; i++) {
        if ((str.charCodeAt(i) >= 65 && str.charCodeAt(i) <= 90) || (str.charCodeAt(i) >= 97 && str.charCodeAt(i) <= 122)) {
            count += 1
        }
    }

    return count >= 2 ? true : false

}
export default AddAppointment
